export default __webpack_public_path__ + "assets/ico_rule_on_btn-893015e1.svg";